import { connect } from 'react-redux';
import SubscriptionInfo from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionInfo);
